import BaseStore from '@src/utils/store/base-store';
import useMount from '@src/utils/hooks/use-mount';
import InnerWrapStore from '@src/pages/inner-wrap/store';
import { observable } from 'mobx';
import { getParameterByNames } from '@src/utils/device';
import AntdMessage from '@src/components/antd/message';
import { getOmniData, getOmniDetail, newData } from '@src/services/omni-api';
import createHtmlLink from '@src/utils/create-html-link';
import buildRouteUrl from '@src/utils/build-route-url';
import { convertPxToRem } from '@src/utils/convert-px-to-rem';

class NewsDetailStore extends BaseStore {
  innerWrapStore = new InnerWrapStore({
    title: '江湖快报',
    current: 1,
    type: 'news-detail'
  });

  @observable detailData = {};
  @observable prevData = {};
  @observable nextData = {};
  @observable page = 1;
  @observable pageSize = 10;

  getDetail = async () => {
    const contentId = getParameterByNames('contentId');

    if (!contentId) {
      AntdMessage.error('参数错误');
      return;
    }
    try {
      AntdMessage.loading('加载中...', 0);
      const res = await getOmniDetail(contentId);
      if (res) {
        AntdMessage.destroy();
        let content = convertPxToRem(res.content);
        this.detailData = {
          ...res,
          content: content
        };
      }
    } catch (error) {
      AntdMessage.destroy();
      AntdMessage.error('获取详情失败');
    }
  };

  // 获取所有数据，作为上下一个判断
  getAllDeatil = async () => {
    const categoryId = getParameterByNames('categoryId');
    const page = getParameterByNames('page') ? Number(getParameterByNames('page')) : 1;
    this.page = page;
    if (!categoryId) {
      AntdMessage.error('参数错误');
      return;
    }
    try {
      const res = await getOmniData('channel_cat_e9f08e88', [
        {
          dataSourceId: categoryId,
          page: page,
          perPage: this.pageSize
        }
      ]);
      const detailList = res?.[categoryId]?.result?.items || [];
      const contentId = getParameterByNames('contentId');
      // 设置 上一页、下一页数据
      const index = detailList.findIndex(item => item.contentId === contentId);
      if (index === 0) {
        // index为0,判断前面是否还有页数
        if (this.page === 1) {
          this.prevData = {};
        } else {
          const prevRes = await getOmniData('channel_cat_e9f08e88', [
            {
              dataSourceId: categoryId,
              page: page - 1,
              perPage: this.pageSize
            }
          ]);
          this.prevData = prevRes?.[categoryId]?.result?.items?.[prevRes?.[categoryId]?.result?.items?.length - 1] || {};
        }
        this.nextData = detailList[index + 1] || {};
      } else if (index === detailList.length - 1) {
        // index=最后一项,判断后面是否还有数据
        const nextRes = await getOmniData('channel_cat_e9f08e88', [
          {
            dataSourceId: categoryId,
            page: page + 1,
            perPage: this.pageSize
          }
        ]);
        this.prevData = detailList[index - 1] || {};
        this.nextData = nextRes?.[categoryId]?.result?.items?.[0] || {};
      } else {
        this.prevData = detailList[index - 1] || {};
        this.nextData = detailList[index + 1] || {};
      }
    } catch (error) {}
  };

  gotoDetail = item => {
    if (!item.title) {
      return;
    }
    if (item.jump_link === 'stay') {
      return;
    }
    const categoryId = getParameterByNames('categoryId');
    if (item.jump_link === 'link') {
      const url = item.art_link.url;
      const link = createHtmlLink(url);
      link.target = '_blank';
      link.click();
    } else {
      // 切换上一篇/下一篇: 更新 hash 内的 contentId, 其余参数保持
      const url = buildRouteUrl('/news-detail', {
        contentId: item.contentId,
        categoryId,
        page: this.page
      });
      window.history.replaceState({}, '', url);
      // 滚动到顶部
      document.documentElement.scrollTop = 0;
      document.body.scrollTop = 0;
      this.getDetail();
      this.getAllDeatil();
    }
  };

  /**
   * 初始化面包屑
   */
  initBreadcrumb = () => {
    const breadcrumb = [
      {
        title: '江湖快报',
        link: '/?currentPage=1'
      }
    ];
    const categoryId = getParameterByNames('categoryId');
    const currentNews = newData.find(item => item.id === categoryId);
    breadcrumb.push({
      title: currentNews?.title || '',
      link: `/news-list?categoryId=${categoryId}`
    });
    breadcrumb.push({
      title: '正文',
      link: ''
    });
    this.innerWrapStore.breadcrumb = breadcrumb;
  };

  use() {
    super.use();
    useMount(() => {
      this.initBreadcrumb();
      this.getDetail();
      this.getAllDeatil();
    });
  }
}

export default NewsDetailStore;
